/* eslint-disable no-console, no-unused-vars */
import './modules/globals';
import './modules/location-utils';
import './modules/modals';
import './modules/sliders';
import './modules/tabs';
import './modules/video-gallery';
import './modules/widen-image-utils';
import './modules/product-solutions-gallery';

import * as CreateAccount from './modules/consumer-account/create-account';
import * as ForgotPassword from './modules/consumer-account/forgot-password';
import * as FormValidationUtils from './utils/form-validation-utils';
import * as Login from './modules/consumer-account/login';
import * as ManageAccount from './modules/consumer-account/manage-account';
import * as StorageActions from './modules/consumer-account/storage-actions';
import * as SwatchbookUtils from './modules/swatchbook-utils';
import * as VueTemplates from './modules/consumer-account/vue-templates';

import { attachNavEvents, buildPaginationHtml, resizeSliderArrows } from './modules/color-books';
import {
  dispatchSiteEvent,
  initSiteEvents,
} from './events/site-events';
import {
  getDigitalUserId,
  getLoggedInStatus,
  getUserId,
} from './modules/consumer-account/authentication';
import { getValByCustomFieldName } from './utils/drip-utils';

import DesktopNavMenus from './modules/desktop-nav-menus';
import FlipCards from './modules/flip-cards';
import GridSliders from './modules/grid-sliders';
import HeaderSearch from './modules/header-search';
import ImageComparisonSlider from './modules/image-comparison-slider';
import InPageNav from './modules/in-page-nav';
import LazyLoad from './modules/lazyload';
import LocalNav from './modules/local-nav';
import MiniGallery from './modules/mini-gallery';
import MinifiedHeader from './modules/minified-header';
import MobileNavNew from './modules/mobile-nav-new';
import SiteModal from './modules/site-modal';
import SwatchCartIndicator from './modules/swatch-cart-indicator';
import TabRole from './modules/accessibility/tab-role';
import Tabnav from './modules/tabnav';
import { addTooltipsOnPageLoad } from './modules/tooltips';
import { announceMessage } from './modules/accessibility/status-messages';
import { bundleSelector } from './modules/new-dealer-sampling';
import { getCookie } from './modules/signup-form';
import { getParameterByName } from './utils/url-utils';
import { logout } from './modules/consumer-account/account-api';

window.SiteModal = SiteModal;
window.dispatchSiteEvent = dispatchSiteEvent;
window.localTesting = false;
window.getDigitalUserId = getDigitalUserId;
window.isAuthenticated = getLoggedInStatus();
window.useLocalStorage = false;
window.userId = getUserId();
window.micrositeName = 'graberblinds';
window.brandId = '2';
window.jsVersion = '2.1.5';

// Local Storage
window.ls.isLocalStorage = window.ls.localStorageCheck();
// Swatchbook
window.swatchbook = SwatchbookUtils;
window.swatchbook.init();
window.swatchbook.data = window.swatchbook.getSwatchbookData();
// Sliders
window.sliders.init();
// Account methods
window.Login = Login;
window.Login.init();
window.FormValidationUtils = FormValidationUtils;
window.StorageActions = StorageActions;
window.VueTemplates = VueTemplates;
window.ForgotPassword = ForgotPassword;
// Global reference for GA, accessibility utils
window.announceMessage = announceMessage;
window.getParameterByName = getParameterByName;
// Get cookie function from signup-form. used to detect isGraberDealer cookie
window.getCookie = getCookie;
// GTM legacy dependencies
window.epiHelpers = {
  getValByMailchimpField: (name) => {
    getValByCustomFieldName(document, name);
  },
};

DesktopNavMenus();
FlipCards();
HeaderSearch();
ImageComparisonSlider.initComparisons();
initSiteEvents();
LazyLoad();
LocalNav();
MinifiedHeader({
  headerDiv: document.querySelector('.header'),
  minClass: 'is-fixed',
});
MobileNavNew();
addTooltipsOnPageLoad();
GridSliders();
MiniGallery();
SwatchCartIndicator();
Tabnav();
TabRole(); // Accessibility

window.logoutUser = () => {
  logout({
    onSuccess: () => {
      window.swatchbook.clearAllSwatchbookData();
      window.location = window.loginUrl;
    },
  });
};

if (document.querySelector('.manage-acct-content') !== null) {
  ManageAccount.init();
}
// Create Account, Modal
if (document.querySelector('.modal-acct-create-form') !== null) {
  CreateAccount.init({
    form: document.querySelector('.modal-acct-create-form'),
    disableScroll: true,
  });
}
// Create Account, In-Page
if (document.querySelector('.acct-create-form') !== null) {
  CreateAccount.init({
    form: document.querySelector('.acct-create-form'),
    disableScroll: false,
  });
}
if (document.querySelector('.in-page-nav') !== null) {
  InPageNav();
}
// Build colorbook pagination
if (document.querySelector('.sidebar-nav') !== null) {
  buildPaginationHtml();
  attachNavEvents('.nav-section-heading');
  window.addEventListener('resize', resizeSliderArrows);
  const itemsWithCaptions = document.querySelectorAll('.image-with-caption');
  itemsWithCaptions.forEach(item => item.addEventListener('touchstart', () => item.classList.toggle('touched')));
}
/* eslint-enable no-console, no-unused-vars */

// initialize New Dealer Sampling
bundleSelector();
